<script>
import { Attachment } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'
import moment from 'moment'

export default {
  mixins: [ListMixin],
  data() {
    return {
      verboseName: 'Załącznik',
      verboseNamePlural: 'Załączniki',
      listFields: [
        { prop: 'file', label: 'url' },
        { label: 'data', formatter: this.formatDate('timestamp') }
      ]
    }
  },
  methods: {
    actions(scope) {
      return [
        {
          type: 'danger',
          icon: 'el-icon-delete',
          method: scope => this.handleDelete(scope.$index, scope.row),
          component: 'el-button'
        }
      ]
    }
  },
  computed: {
    service() {
      return Attachment
    }
  }
}
</script>
